export interface IDashboardNavItem {
  text: string;
  img: string;
  path: string;
  forManager: boolean;
  forSuperAdmin?: boolean;
}

export const isDashboardNavItemVisible = (
  item: Pick<IDashboardNavItem, "forManager" | "forSuperAdmin">,
  viewer: { isAdmin: boolean; isCommunityManager: boolean },
): boolean => {
  if (item.forSuperAdmin) {
    return viewer.isAdmin;
  }
  if (item.forManager) {
    return viewer.isAdmin || viewer.isCommunityManager;
  }
  return true;
};
